import { render } from "./WhatWeDoBest.vue?vue&type=template&id=b5571d7e&scoped=true"
import script from "./WhatWeDoBest.vue?vue&type=script&lang=ts"
export * from "./WhatWeDoBest.vue?vue&type=script&lang=ts"

import "./WhatWeDoBest.vue?vue&type=style&index=0&id=b5571d7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5571d7e"

export default script